import axios from 'axios'
import qs from 'qs'

const instance = axios.create({
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    transformRequest: [function (data) {
        console.log(data);
        if (data) {
            data = qs.stringify(data);
        }
        return data;
    }],
    // baseURL: '',
    baseURL: '/',

    timeout: 30000
    // withCredentials: true
})

// 添加请求拦截器
instance.interceptors.request.use(config => {
    let token = localStorage.getItem('token');
    console.log(config);
    // 在发送请求之前做某事，比如说 设置token
    if(config.data){
        config.data.token = token;
    }
    return config;
}, error => {
    // 请求错误时做些事
    return Promise.reject('1111',error);
});

// 添加响应拦截器
instance.interceptors.response.use(response => {
    console.log(response);
    // 对响应数据做些事
    if (response.status === 200) {
        console.log(response)
        // && response.data.data.code
        if (response.data.code != 401) {
            console.log('成功')
            // response.data.data.value = '我是返回成功' // 在请求成功后可以对返回的数据进行处理，再返回到前台
        } else {
            console.log(123)
            // alert(111)
            // window.location.href = "#/login?loadType=1";
            // this.$router.push({
            //     path: "/login",
            //   });
            if(sessionStorage.getItem("loadType") == '1'){
                // alert(111)
                // setInterval(() => {
                    window.location.href = "#/login?loadType=1";
            // }, 500);
            }else {
                window.location.href = "#/login"
            }

        }
    }
    return response;
}, error => {
    console.log(error);
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
})

export default instance;



// WEBPACK FOOTER //
// ./src/http/http.js